var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[(_vm.initialized)?_c('div',{staticClass:"col-12"},[_c('LocationSettingsHeader'),_c('SlideFadeTransition',[_c('router-view')],1)],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }